import script from "./BalChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalChip.vue?vue&type=script&setup=true&lang=ts"

import "./BalChip.vue?vue&type=style&index=0&id=294eb19f&scoped=true&lang=css"
script.__scopeId = "data-v-294eb19f"

export default script